<header id="page-topbar">
    <div class="layout-width">
        <div class="navbar-header">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box horizontal-logo">
                    <a routerLink="/" class="logo logo-dark" aria-label="Belatz - Ir al inicio">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.webp" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo-dark.webp" alt="Belatz" height="17">
                        </span>
                    </a>

                    <a routerLink="/" class="logo logo-light" aria-label="Belatz - Ir al inicio">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.webp" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo-light.webp" alt="Belatz" height="17">
                        </span>
                    </a>
                </div>

                <button type="button"
                    class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                    id="topnav-hamburger-icon"
                    aria-label="Abrir menú"
                    (click)="toggleMenu()">
                    <span class="hamburger-icon" aria-hidden="true">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>

                <!-- App Search -->
                <form class="app-search d-none d-md-block" role="search" (submit)="$event.preventDefault()">
                    <div class="position-relative">
                        <label for="search-options" class="visually-hidden">Ir a un módulo del sistema</label>
                        <input type="text" class="form-control" placeholder="Ir a catálogo o proceso..."
                            autocomplete="off" id="search-options"
                            name="searchOptions"
                            [ngModel]="searchTerm()" 
                            (ngModelChange)="searchTerm.set($event)">
                        <span class="mdi mdi-magnify search-widget-icon" aria-hidden="true"></span>
                        <span class="mdi mdi-close-circle search-widget-icon search-widget-icon-close"
                            [class.d-none]="!searchTerm()"
                            id="search-close-options" aria-hidden="true" (click)="searchTerm.set('')" style="cursor:pointer"></span>
                    </div>

                    @if (searchTerm() && searchResults().length > 0) {
                        <div class="dropdown-menu dropdown-menu-lg shadow show w-100 p-0" style="position: absolute; top: 100%; left: 0;">
                            <div class="px-3 pt-2 pb-1 border-bottom">
                                <h5 class="fs-13 text-muted mb-0">Módulos sugeridos</h5>
                            </div>
                            <div class="py-2" style="max-height: 300px; overflow-y: auto;">
                                @for (result of searchResults(); track result.route) {
                                    <a href="javascript:void(0);" class="dropdown-item notify-item d-flex align-items-center py-2" (click)="navigateTo(result)">
                                        <i class="{{ result.icon || 'ri-layout-grid-line' }} text-muted fs-18 align-middle me-2"></i>
                                        <div>
                                            <span class="fw-medium text-body d-block">{{ result.label }}</span>
                                            @if (result.parentLabel) {
                                                <span class="fs-11 text-muted">{{ result.parentLabel }}</span>
                                            }
                                        </div>
                                    </a>
                                }
                            </div>
                        </div>
                    } @else if (searchTerm() && searchResults().length === 0) {
                        <div class="dropdown-menu shadow show w-100 p-3" style="position: absolute; top: 100%; left: 0;">
                            <div class="text-center">
                                <i class="ri-search-line fs-24 text-muted mb-2"></i>
                                <h6 class="fs-13 text-muted mb-0">No se encontraron resultados para "{{ searchTerm() }}"</h6>
                            </div>
                        </div>
                    }
                </form>
            </div>

            <div class="d-flex align-items-center">

                <!-- Búsqueda móvil -->
                <div class="dropdown d-md-none topbar-head-dropdown ms-1 header-item">
                    <button type="button"
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        aria-label="Buscar"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="bx bx-search fs-22" aria-hidden="true"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
                        <form class="p-3 border-bottom" role="search" (submit)="$event.preventDefault()">
                            <div class="input-group">
                                <label for="search-mobile" class="visually-hidden">Ir a un módulo del sistema</label>
                                <input type="text" id="search-mobile" name="searchMobile" class="form-control" placeholder="Ir a catálogo o proceso..."
                                    [ngModel]="searchTerm()" (ngModelChange)="searchTerm.set($event)">
                                <button class="btn btn-primary" type="submit" aria-label="Ejecutar búsqueda">
                                    <i class="mdi mdi-magnify" aria-hidden="true"></i>
                                </button>
                            </div>
                        </form>
                        @if (searchTerm() && searchResults().length > 0) {
                            <div class="py-2" style="max-height: 300px; overflow-y: auto;">
                                @for (result of searchResults(); track result.route) {
                                    <a href="javascript:void(0);" class="dropdown-item notify-item d-flex align-items-center py-2" (click)="navigateTo(result)">
                                        <i class="{{ result.icon || 'ri-layout-grid-line' }} text-muted fs-18 align-middle me-2"></i>
                                        <div>
                                            <span class="fw-medium text-body d-block">{{ result.label }}</span>
                                            @if (result.parentLabel) {
                                                <span class="fs-11 text-muted">{{ result.parentLabel }}</span>
                                            }
                                        </div>
                                    </a>
                                }
                            </div>
                        } @else if (searchTerm() && searchResults().length === 0) {
                            <div class="p-3 text-center">
                                <i class="ri-search-line fs-24 text-muted mb-2"></i>
                                <h6 class="fs-13 text-muted mb-0">No se encontraron resultados</h6>
                            </div>
                        }
                    </div>
                </div>

                <!-- Ciclo vigente de la empresa activa -->
                @if (activeCycle(); as cycle) {
                <div class="header-item cycle-indicator d-none d-lg-flex align-items-center"
                    [title]="'Ciclo vigente: ' + cycle.name">
                    <i class="bx bx-calendar-event fs-16 me-2" aria-hidden="true"></i>
                    <span class="cycle-label">
                        <span class="cycle-name">{{ cycle.name }}</span>
                    <!-- Mes abreviado: con el mes completo el rango no cabia y la fecha final
                         salia cortada. El globo del rotulo lleva el nombre del ciclo entero. -->
                    <span class="cycle-range">{{ cycle.startDate | date:"d MMM y":'UTC' }} al {{ cycle.endDate | date:"d MMM y":'UTC' }}</span>
                    </span>
                </div>
                }

                <!-- ══════════════════════════════════════════════════
                     COMPANY SWITCHER
                ═══════════════════════════════════════════════════════ -->
                @if (companies().length > 0) {
                <div class="dropdown topbar-head-dropdown ms-1 header-item company-switcher">
                    <button type="button"
                        class="btn btn-topbar company-switcher-btn d-flex align-items-center gap-2"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        [disabled]="switchingCompany()">

                        @if (switchingCompany()) {
                            <span class="spinner-border spinner-border-sm" role="status"></span>
                        } @else {
                            <span class="company-label">
                                <span class="company-code">{{ authService.activeCompany()?.shortName ?? '??' }}</span>
                                <span class="company-sep" aria-hidden="true">·</span>
                                <span class="company-name">{{ authService.activeCompany()?.name ?? 'Empresa' }}</span>
                            </span>
                        }
                        <i class="bx bx-chevron-down fs-14 ms-1"></i>
                    </button>

                    <div class="dropdown-menu dropdown-menu-end company-dropdown p-2" style="min-width:240px">
                        <div class="px-2 pt-1 pb-2 mb-1 border-bottom">
                            <p class="text-muted fs-11 mb-0 text-uppercase fw-semibold">Empresa activa</p>
                        </div>
                        @for (co of companies(); track co.businessNameId) {
                            <button type="button"
                                class="dropdown-item rounded-2 d-flex align-items-center gap-3 px-2 py-2"
                                [class.active]="co.businessNameId === authService.activeCompany()?.businessNameId"
                                (click)="selectCompany(co)">
                                <span class="company-avatar company-avatar--sm">
                                    {{ co.shortName.slice(0,2) || '??' }}
                                </span>
                                <span class="flex-grow-1 text-start">
                                    <span class="d-block fw-medium fs-13">{{ co.name }}</span>
                                    <span class="d-block text-muted fs-11">{{ co.shortName }}</span>
                                </span>
                                @if (co.businessNameId === authService.activeCompany()?.businessNameId) {
                                    <i class="bx bx-check fs-16 text-primary"></i>
                                }
                            </button>
                        }
                    </div>
                </div>
                }
                <!-- ── /COMPANY SWITCHER ─────────────────────────── -->

                <!-- ══════════════════════════════════════════════════
                     THEME SWITCHER DROPDOWN
                ═══════════════════════════════════════════════════════ -->
                <div class="dropdown topbar-head-dropdown ms-1 header-item theme-switcher-dropdown">
                    <button
                        type="button"
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle theme-toggle-btn"
                        [attr.aria-label]="'Cambiar tema — modo ' + themeLabel"
                        data-bs-toggle="dropdown"
                        data-bs-auto-close="true"
                        aria-haspopup="true"
                        aria-expanded="false">

                        <!-- Ícono dinámico según modo activo -->
                        <i [class]="themeIcon + ' fs-22 theme-icon'" aria-hidden="true"></i>

                        <!-- Indicador visual del modo activo -->
                        <span class="theme-mode-dot"
                            [class.dot-system]="layoutService.themeMode() === 'system'"
                            [class.dot-dark]="layoutService.themeMode() === 'dark'"
                            [class.dot-light]="layoutService.themeMode() === 'light'"
                            aria-hidden="true">
                        </span>
                    </button>

                    <div class="dropdown-menu dropdown-menu-end theme-dropdown-menu p-2">

                        <!-- Cabecera del menú -->
                        <div class="px-2 pt-1 pb-2 mb-1 border-bottom">
                            <p class="text-muted fs-11 mb-0 text-uppercase fw-semibold ls-1">
                                Apariencia
                            </p>
                        </div>

                        <!-- Opción: Claro -->
                        <button
                            type="button"
                            class="dropdown-item theme-option rounded-2 d-flex align-items-center gap-3 px-2 py-2"
                            [class.active]="layoutService.themeMode() === 'light'"
                            (click)="setTheme('light')">
                            <span class="theme-option-icon">
                                <i class="bx bx-sun fs-18"></i>
                            </span>
                            <span class="flex-grow-1">
                                <span class="d-block fw-medium fs-13">Claro</span>
                                <span class="d-block text-muted fs-11">Siempre tema claro</span>
                            </span>
                            @if (layoutService.themeMode() === 'light') {
                                <span class="theme-check">
                                    <i class="bx bx-check fs-16 text-primary"></i>
                                </span>
                            }
                        </button>

                        <!-- Opción: Oscuro -->
                        <button
                            type="button"
                            class="dropdown-item theme-option rounded-2 d-flex align-items-center gap-3 px-2 py-2"
                            [class.active]="layoutService.themeMode() === 'dark'"
                            (click)="setTheme('dark')">
                            <span class="theme-option-icon">
                                <i class="bx bx-moon fs-18"></i>
                            </span>
                            <span class="flex-grow-1">
                                <span class="d-block fw-medium fs-13">Oscuro</span>
                                <span class="d-block text-muted fs-11">Siempre tema oscuro</span>
                            </span>
                            @if (layoutService.themeMode() === 'dark') {
                                <span class="theme-check">
                                    <i class="bx bx-check fs-16 text-primary"></i>
                                </span>
                            }
                        </button>

                        <!-- Opción: Sistema -->
                        <button
                            type="button"
                            class="dropdown-item theme-option rounded-2 d-flex align-items-center gap-3 px-2 py-2"
                            [class.active]="layoutService.themeMode() === 'system'"
                            (click)="setTheme('system')">
                            <span class="theme-option-icon">
                                <i class="bx bx-desktop fs-18"></i>
                            </span>
                            <span class="flex-grow-1">
                                <span class="d-block fw-medium fs-13">Sistema</span>
                                <span class="d-block text-muted fs-11">
                                    Sigue la preferencia del SO
                                    <span class="badge badge-soft-secondary ms-1 fs-10 py-0 px-1">
                                        {{ layoutService.effectiveTheme() === 'dark' ? 'Oscuro' : 'Claro' }}
                                    </span>
                                </span>
                            </span>
                            @if (layoutService.themeMode() === 'system') {
                                <span class="theme-check">
                                    <i class="bx bx-check fs-16 text-primary"></i>
                                </span>
                            }
                        </button>

                    </div>
                </div>
                <!-- ── /THEME SWITCHER ────────────────────────────── -->

                <!-- Reportar un problema -->
                <div class="topbar-head-dropdown ms-1 header-item">
                    <app-support-widget />
                </div>

                <!-- Notificaciones -->
                <!-- Sin data-bs-toggle="dropdown": este boton no tiene .dropdown-menu
                     y Bootstrap se quedaba con el menu en null, reventando con
                     "Cannot read properties of null (reading 'classList')" en
                     cualquier pantalla, porque el header es global (182875, 49BB4B).
                     Cuando exista la bandeja de notificaciones se vuelve a conectar. -->
                <div class="dropdown topbar-head-dropdown ms-1 header-item" id="notificationDropdown">
                    <button type="button"
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        aria-label="Notificaciones">
                        <i class='bx bx-bell fs-22' aria-hidden="true"></i>
                    </button>
                </div>

                <!-- Usuario -->
                <div class="dropdown ms-sm-3 header-item topbar-user">
                    <button type="button" class="btn"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                            @if (currentUser().avatarUrl) {
                                <img class="rounded-circle header-profile-user"
                                    [src]="currentUser().avatarUrl" alt="Header Avatar">
                            } @else {
                                <span class="user-avatar-container me-xl-1" title="Perfil de usuario">
                                    <svg class="user-avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                        <defs>
                                            <linearGradient id="avatar-bg-grad" x1="0%" y1="0%" x2="100%" y2="100%">
                                                <stop offset="0%" stop-color="#405189" />
                                                <stop offset="100%" stop-color="#0ab39c" />
                                            </linearGradient>
                                            <linearGradient id="avatar-glow-grad" x1="0%" y1="0%" x2="100%" y2="0%">
                                                <stop offset="0%" stop-color="#299cdb" />
                                                <stop offset="100%" stop-color="#0ab39c" />
                                            </linearGradient>
                                        </defs>
                                        <circle cx="50" cy="50" r="45" fill="none" stroke="url(#avatar-glow-grad)" stroke-width="3" stroke-dasharray="10 5" class="glow-ring" />
                                        <circle cx="50" cy="50" r="38" fill="url(#avatar-bg-grad)" class="bg-circle" />
                                        <g class="user-silhouette">
                                            <circle cx="50" cy="38" r="13" fill="#ffffff" />
                                            <path d="M50 56 C35 56 28 66 28 73 C28 75 29 76 31 76 L69 76 C71 76 72 75 72 73 C72 66 65 56 50 56 Z" fill="#ffffff" />
                                        </g>
                                    </svg>
                                </span>
                            }
                            <span class="text-start ms-xl-2">
                                <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{ currentUser().username }}</span>
                                <span class="d-none d-xl-block ms-1 fs-12 user-name-sub-text">{{ currentUser().role }}</span>
                            </span>
                        </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-end">
                        <h6 class="dropdown-header">¡Hola, {{ currentUser().username }}!</h6>
                        <a class="dropdown-item" routerLink="/perfil">
                            <i class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle">Perfil</span>
                        </a>
                        @if (!esCuentaMaster()) {
                        <a class="dropdown-item" href="javascript:void(0);" (click)="abrirCambioContrasena()">
                            <i class="mdi mdi-key text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle">Cambiar contraseña</span>
                        </a>
                        }
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0);" (click)="lockSession()">
                            <i class="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle">Bloquear pantalla</span>
                        </a>
                        <a class="dropdown-item" href="javascript:void(0);" (click)="authService.signOut()">
                            <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle">Cerrar sesión</span>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</header>

<!-- Aviso previo a la caducidad de la contrasena -->
@if (avisoCaducidad() !== null) {
    <div class="aviso-caducidad alert alert-warning d-flex align-items-center gap-2 shadow mb-0" role="status">
        <i class="mdi mdi-alert-outline fs-18"></i>
        <span class="flex-grow-1">{{ textoCaducidad() }}</span>
        <button type="button" class="btn btn-sm btn-warning text-nowrap" (click)="abrirCambioContrasena()">Cambiar ahora</button>
        <button type="button" class="btn btn-sm btn-link text-reset p-0" aria-label="Cerrar el aviso"
                title="Cerrar el aviso" (click)="descartarAvisoCaducidad()">
            <i class="mdi mdi-close fs-18"></i>
        </button>
    </div>
}

<!-- Cambio voluntario de la contraseña propia -->
<app-cambiar-contrasena-dialog [(visible)]="showCambio"
                               [cuenta]="cambioCuenta"
                               (cambiada)="onContrasenaCambiada()" />
